import * as React from "react";
import { StyleSheetManager } from "styled-components";

import { createExtraSpecificityPlugin } from "./stylis-extra-specificity-plugin";

const increaseSpecificityPlugin = createExtraSpecificityPlugin(2);

type Props = {
  children: React.ReactNode;
};

export function MFEStyleSheetManager({ children }: Props) {
  return (
    <StyleSheetManager stylisPlugins={[increaseSpecificityPlugin]}>
      {children}
    </StyleSheetManager>
  );
}
